import React from 'react';
import { PageHero } from '../components/ui/PageHero';
import { Container, Eyebrow, Heading } from '../components/ui/Section';
import { CtaBand } from '../components/ui/CtaBand';
import { ModelSteps } from '../components/features/ModelSteps';
import { IMAGES, VALUES } from '../data/solutions';
import { CONTACT, VERBS } from '../data/site';
import { localBusinessJsonLd, useSeo } from '../utils/seo';
const CRUMBS = [{
  name: 'Inicio',
  path: '/'
}, {
  name: 'Nosotros',
  path: '/nosotros'
}];
export function About() {
  useSeo({
    title: 'Sobre Rabemar | Servicios integrales para empresas en Argentina',
    description: 'Rabemar Servicios Integrales elimina complejidad de las operaciones empresariales integrando logística, Facility Management, tecnología, seguridad y gestión.',
    path: '/nosotros',
    image: IMAGES.team,
    breadcrumbs: CRUMBS,
    jsonLd: [localBusinessJsonLd]
  });
  return <>
      <PageHero eyebrow="Sobre Rabemar" title="Eliminar complejidad de las operaciones empresariales." lead="Integramos conocimiento logístico, Facility Management, tecnología, seguridad y gestión para construir soluciones adaptadas a cada cliente." image={IMAGES.team} imageAlt="Equipo de profesionales de operaciones de Rabemar en el área de muelles de un depósito" crumbs={CRUMBS} ctaLabel="Hablar con un especialista" data-id="element-502" data-mp="1luu9zb9voif9" />

      <section className="bg-white py-20 md:py-28" data-id="element-503" data-mp="2dfm9p532eiog">
        <Container data-id="element-504" data-mp="2deb8nd107p11">
          <div className="grid gap-14 lg:grid-cols-[1fr_1fr] lg:gap-20" data-id="element-505" data-mp="28ht2q9txtkn4">
            <div data-id="element-506" data-mp="28fqh01ztido7">
              <Eyebrow data-id="element-507" data-mp="2m8pww53ii9wa">Quiénes somos</Eyebrow>
              <Heading as="h2" size="md" className="mt-5" data-id="element-508" data-mp="2m7obb6ove50b">
                Una operación coordinada, medible y eficiente.
              </Heading>
              <div className="mt-6 space-y-5 text-lg leading-relaxed text-graphite-500" data-id="element-509" data-mp="2w75e9gcqm4sl">
                <p data-id="element-510" data-mp="2w4suqyrbzmdf">
                  Rabemar Servicios Integrales nace con una visión simple: eliminar complejidad de las operaciones
                  empresariales.
                </p>
                <p data-id="element-511" data-mp="1osjtgsyqex8y">
                  Integramos conocimiento logístico, Facility Management, tecnología, seguridad y gestión para construir
                  soluciones adaptadas a cada cliente.
                </p>
                <p data-id="element-512" data-mp="22m19i3s7lru8">
                  Nuestro objetivo es transformar múltiples servicios, proveedores y procesos dispersos en una operación
                  coordinada, medible y eficiente.
                </p>
              </div>
              <ul className="mt-10 flex flex-wrap gap-x-8 gap-y-3" data-id="element-513" data-mp="2cjfpy3e4ugmj">
                {VERBS.map(verb => <li key={verb} className="font-display text-xl font-bold tracking-tight text-graphite-900" data-id="element-514" data-mp="2gmvmkzq7cgz8">
                    {verb}.
                  </li>)}
              </ul>
            </div>

            <div data-id="element-515" data-mp="m9cg30e71o1s">
              <p className="text-xs font-semibold uppercase tracking-[0.14em] text-graphite-500" data-id="element-516" data-mp="m9w0qov8aqji">Valores</p>
              <ul className="mt-5 divide-y divide-mist-200 border-y border-mist-200" data-id="element-517" data-mp="r8pfekm94nl9">
                {VALUES.map((value, i) => <li key={value} className="flex items-baseline gap-5 py-4" data-id="element-518" data-mp="ew4u4bu2thxf" data-mpi={i}>
                    <span className="font-display text-xs font-bold tabular-nums text-accent-500" data-id="element-519" data-mp="9xjv2fqk94ak">
                      {String(i + 1).padStart(2, '0')}
                    </span>
                    <span className="font-display text-lg font-semibold tracking-tight text-graphite-900" data-id="element-520" data-mp="4we2chwwhh11">{value}</span>
                  </li>)}
              </ul>
              <div className="mt-9 border border-mist-200 bg-mist-50 p-6" data-id="element-521" data-mp="xnnwcgga0rye">
                <p className="text-xs font-semibold uppercase tracking-[0.14em] text-graphite-500" data-id="element-522" data-mp="sn08g3ncgr8e">Base operativa</p>
                <p className="mt-3 text-sm leading-relaxed text-graphite-800" data-id="element-523" data-mp="olwszi97kx7p">{CONTACT.address}</p>
                <p className="mt-2 text-sm leading-relaxed text-graphite-500" data-id="element-524" data-mp="3dftxbuo722zo">
                  Capacidad de cobertura en todo el territorio argentino con flota propia y red 3PL.
                </p>
              </div>
            </div>
          </div>
        </Container>
      </section>

      <section className="bg-mist-50 py-20 md:py-28" data-id="element-525" data-mp="15vqxjh1gu24l">
        <Container data-id="element-526" data-mp="r5t8kyvpp8ec">
          <div className="max-w-3xl" data-id="element-527" data-mp="r6b9w9x8ect4">
            <Eyebrow data-id="element-528" data-mp="r7e2qne46pbo">Modelo Rabemar</Eyebrow>
            <Heading as="h2" size="md" className="mt-5" data-id="element-529" data-mp="w4mlap36cvdg">
              Cómo trabajamos.
            </Heading>
          </div>
          <ModelSteps data-id="element-530" data-mp="1ju7334nldml5" />
          <div className="mt-14 border-t border-mist-200 pt-10" data-id="element-531" data-mp="1jv05jtfippxh">
            <p className="font-display text-2xl font-bold leading-tight tracking-tight text-graphite-900 md:text-3xl" data-id="element-532" data-mp="1ottjfmypviy6">
              No vendemos horas.
              <br data-id="element-533" data-mp="1avv52hkebmio" />
              Diseñamos operaciones que funcionan.
            </p>
          </div>
        </Container>
      </section>

      <CtaBand title="Conversemos sobre su operación." text="Un especialista puede revisar su situación actual y proponer un alcance concreto, medible y acotado para empezar." primaryLabel="Solicitar diagnóstico" location="nosotros-cta" data-id="element-534" data-mp="3vjhx0jf8tvav" />
    </>;
}